import type { Replace } from '../../../shared/lib/typeHelpers.no-deps'
import type {
    ActivityWorkflow as ServerActivityWorkflow,
    AppFlowWorkflow,
    WorkflowActivity as ServerWorkflowActivity,
} from '../../../shared/domain/workflows/types.no-deps'
import { isNil } from '../../../shared/lib/functional/nil.no-deps'

export type Workflow = AppActivityWorkflow | AppFlowWorkflow

// The app enriches the activities with information that cannot be represented
// with the WorkflowActivity type that the server uses
export type AppActivityWorkflow = Replace<ServerActivityWorkflow, { activities: AppWorkflowActivity[] }>

/** AppWorkflowActivity
 *
 *   It's a legacy workflow.
 *   It's like a flow but uses a different data structure to define the steps to complete and the result of
 *   executing it in the app yields a different data structure which is stored in reports.data as opposed
 *   to reports.answer and report_answers
 */
export type AppWorkflowActivity = ServerWorkflowActivity & {
    note?: string
    completed?: boolean
    selected?: boolean
    blocked?: boolean
    checked?: boolean
    progress?: {
        count: number
        total: number
    }
}

export interface AppTrainingWorkflow extends AppFlowWorkflow {}

export function isAppActivityWorkflow(workflow: Workflow): workflow is AppActivityWorkflow {
    return !isFlowWorkflow(workflow)
}

export function isFlowWorkflow(workflow: Workflow): workflow is AppFlowWorkflow {
    return 'flow' in workflow && workflow.flow != null
}

export function isWorkflowWithoutUnit(workflow: Workflow): boolean {
    return !isFlowWorkflow(workflow) || isNil(workflow.flow.subjectType)
}

export function isWorkflowForGuide(workflow: Workflow | Pick<Workflow, 'id' | 'name' | 'type'>): boolean {
    return workflow.type === 'guide'
}
